module.exports = __webpack_public_path__ + "img/hk_room_floorplan_05.49d27617.png";